import { useState } from 'react';

import { Button } from '../ui/button';

export interface PauseResumeModalProps {
  mode: 'pause' | 'resume' | null;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
  pending?: boolean;
}

export function PauseResumeModal({ mode, onCancel, onConfirm, pending }: PauseResumeModalProps) {
  const [reason, setReason] = useState('');
  if (!mode) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-sm rounded bg-card p-5 shadow-xl">
        <h2 className="mb-3 text-lg font-semibold">
          {mode === 'pause' ? 'Приостановить канал' : 'Возобновить канал'}
        </h2>
        <label className="mb-1 block text-xs font-medium text-muted-fg" htmlFor="pr-reason">
          Причина (обязательно)
        </label>
        <textarea
          id="pr-reason"
          className="h-20 w-full rounded border border-border bg-bg p-2 text-sm"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="secondary" onClick={onCancel}>
            Отмена
          </Button>
          <Button
            variant={mode === 'pause' ? 'danger' : 'primary'}
            disabled={!reason.trim() || pending}
            onClick={() => onConfirm(reason.trim())}
          >
            {mode === 'pause' ? 'Приостановить' : 'Возобновить'}
          </Button>
        </div>
      </div>
    </div>
  );
}
